import React, { useContext, useState, useEffect } from "react";

/// React router dom
import { Routes, Route, Outlet, Navigate, useLocation } from "react-router-dom";

// web3
import { useAccount, useSignMessage } from "wagmi";

/// Css
import "./index.css";
import "./chart.css";
import "./step.css";

/// Layout
import Nav from "./layouts/nav";
import Footer from "./layouts/Footer";
//import Main from './layouts/Main';

import ScrollToTop from "./layouts/ScrollToTop";
/// Dashboard
import BlocksIndex from "./components/Blocks/BlocksIndex";
import SpotlightBotIndex from "./components/Blocks/SpotlightBot/SpotlightBot";
import SalesBotIndex from "./components/Blocks/SalesBot/SalesBot";
import FlexBotIndex from "./components/Blocks/FlexBot/FlexBot";
import RewardsBotIndex from "./components/Blocks/RewardsBot/RewardsBot";
import SnapshotToolIndex from "./components/Blocks/SnapshotTool/SnapshotTool";

// Landmark
import EventsDashboard from "./components/Blocks/Landmark/EventsDashboard";
import IndustrialTechDashboard from "./components/Blocks/Landmark/IndustrialTechDashboard";
import DealmakersIBDashboard from "./components/Blocks/Landmark/DealmakersIBDashboard";
import IsraelDealPortalDashboard from "./components/Blocks/Landmark/IsraelDealPortalDashboard";
import SISOmniDashboard from "./components/Blocks/Landmark/SISOmniDashboard";
import SISDelegateDashboard from "./components/Blocks/Landmark/SISDelegateDashboard";
import GlobalDashboard from "./components/Blocks/Landmark/GlobalDashboard";
import DynamicEventsDashboard from "./components/Blocks/Landmark/DynamicEventsDashboard";
import CampaignDashboard from "./components/Blocks/Landmark/CampaignDashboard";
import SendoraDashboard from "./components/Blocks/Landmark/SendoraDashboard";
import EmailBounceCleanupDashboard from "./components/Blocks/Landmark/EmailBounceCleanupDashboard";
import CampaignDashboardOld from "./components/Blocks/Landmark/CampaignDashboardOld";
import InvoiceDashboard from "./components/Blocks/Landmark/InvoiceDashboard";
import InvoiceCustomerDashboard from "./components/Blocks/Landmark/InvoiceCustomerDashboard";
import DeDupe from "./components/Blocks/Landmark/DeDupeTool";
import QuickCSVTool from "./components/Blocks/Landmark/QuickCSVTool";
import WelcomePost from "./components/Blocks/Landmark/WelcomePost/WelcomePost";
import ArtGalleryDashboard from "./components/Blocks/ArtGallery/ArtGalleryDashboard";
import ContactParser from "./components/Blocks/Landmark/ContactParserDashboard";
import CeoSniperBotDashboard from "./components/Blocks/Landmark/CeoSniperBotDashboard";
import LinkedInSalesNavDashboard from "./components/Blocks/Landmark/LinkedInSalesNavDashboard";
import LinkedInLeadGeneratorDashboard from "./components/Blocks/Landmark/LinkedInLeadGeneratorDashboard";
import SeamlessBotDashboard from "./components/Blocks/Landmark/SeamlessBotDashboard";
import SeamlessKeywordSearchDashboard from "./components/Blocks/Landmark/SeamlessKeywordSearchDashboard";
import TweetSearchDashboard from "./components/Blocks/Landmark/TweetSearchDashboard";
import BetsDashboard from "./components/Blocks/Bets/BetsDashboard";
import PluginPricesDashboard from "./components/Blocks/PluginPricesDashboard";
import SweeperDashboard from "./components/Blocks/Landmark/SweeperDashboard";
import PersonalizerDashboard from "./components/Blocks/Landmark/PersonalizerDashboard";
import AppetizerDashboard from "./components/Blocks/Landmark/AppetizerDashboard";
import ZoomMeetingDashboard from "./components/Blocks/Landmark/ZoomMeetingDashboard";
import CampaignAttendeeReportingDashboard from "./components/Blocks/Landmark/CampaignAttendeeReportingDashboard";
import PredictionBotDashboard from "./components/Blocks/Landmark/PredictionBotDashboard";
import WebsiteCms from "./components/Blocks/Landmark/Website/WebsiteCms";
import BdDashboard from "./components/Blocks/Landmark/BdDashboard/BdDashboard";
import OppBot from "./components/Blocks/Landmark/OppBot/OppBot";

// rsop
import MarketplaceDashboard from "./components/Blocks/Rsop/MarketplaceDashboard";

import SettingsIndex from "./components/Settings/Settings";

import Home from "./components/Dashboard/Home";
import DashboardDark from "./components/Dashboard/DashboardDark";
import Dashboard2 from "./components/Dashboard/Dashboard2";
import Dashboard3 from "./components/Dashboard/Dashboard3";
import Dashboard4 from "./components/Dashboard/Dashboard4";
import Dashboard5 from "./components/Dashboard/Dashboard5";

//Trading
import Market from "./components/Trading/Market";
import IcoListing from "./components/Trading/IcoListing";
import P2P from "./components/Trading/P2P";
import Future from "./components/Trading/Future";
import IntradayTrading from "./components/Trading/IntradayTrading";

//Crypto
import MarketWatch from "./components/Crypto/MarketWatch";
import IcoListingFilter from "./components/Crypto/IcoListingFilter";
import Banking from "./components/Crypto/Banking";
import Exchange from "./components/Crypto/Exchange";
import CoinDetails from "./components/Crypto/CoinDetails";

//Report
import History from "./components/Report/History";
import Order from "./components/Report/Order";
import Reports from "./components/Report/Reports";
import User from "./components/Report/User";
import Contact from "./components/Report/Contact";
import Activity from "./components/Report/Activity";

/////Demo
import Theme1 from "./components/Dashboard/Demo/Theme1";
import Theme2 from "./components/Dashboard/Demo/Theme2";
import Theme3 from "./components/Dashboard/Demo/Theme3";
import Theme4 from "./components/Dashboard/Demo/Theme4";
import Theme5 from "./components/Dashboard/Demo/Theme5";
import Theme6 from "./components/Dashboard/Demo/Theme6";
import Theme7 from "./components/Dashboard/Demo/Theme7";
import Theme8 from "./components/Dashboard/Demo/Theme8";

/// App
import AppProfile from "./components/AppsMenu/AppProfile/AppProfile";
import EditProfile from "./components/AppsMenu/AppProfile/EditProfile";
import Compose from "./components/AppsMenu/Email/Compose/Compose";
import Inbox from "./components/AppsMenu/Email/Inbox/Inbox";
import Read from "./components/AppsMenu/Email/Read/Read";
import Calendar from "./components/AppsMenu/Calendar/Calendar";
import PostDetails from "./components/AppsMenu/AppProfile/PostDetails";

/// Product List
import ProductGrid from "./components/AppsMenu/Shop/ProductGrid/ProductGrid";
import ProductList from "./components/AppsMenu/Shop/ProductList/ProductList";
import ProductDetail from "./components/AppsMenu/Shop/ProductGrid/ProductDetail";
import Checkout from "./components/AppsMenu/Shop/Checkout/Checkout";
import Invoice from "./components/AppsMenu/Shop/Invoice/Invoice";
import ProductOrder from "./components/AppsMenu/Shop/ProductOrder";
import Customers from "./components/AppsMenu/Shop/Customers/Customers";

/// Charts
import SparklineChart from "./components/charts/Sparkline";
import ChartJs from "./components/charts/Chartjs";
////import Chartist from "./components/charts/chartist";
import RechartJs from "./components/charts/rechart";
import ApexChart from "./components/charts/apexcharts";

/// Bootstrap
import UiAlert from "./components/bootstrap/Alert";
import UiAccordion from "./components/bootstrap/Accordion";
import UiBadge from "./components/bootstrap/Badge";
import UiButton from "./components/bootstrap/Button";
import UiModal from "./components/bootstrap/Modal";
import UiButtonGroup from "./components/bootstrap/ButtonGroup";
import UiListGroup from "./components/bootstrap/ListGroup";
import UiCards from "./components/bootstrap/Cards";
import UiCarousel from "./components/bootstrap/Carousel";
import UiDropDown from "./components/bootstrap/DropDown";
import UiPopOver from "./components/bootstrap/PopOver";
import UiProgressBar from "./components/bootstrap/ProgressBar";
import UiTab from "./components/bootstrap/Tab";
import UiPagination from "./components/bootstrap/Pagination";
import UiGrid from "./components/bootstrap/Grid";
import UiTypography from "./components/bootstrap/Typography";

/// Plugins
import Select2 from "./components/PluginsMenu/Select2/Select2";
import MainNouiSlider from "./components/PluginsMenu/NouiSlider/MainNouiSlider";
import MainSweetAlert from "./components/PluginsMenu/SweetAlert/SweetAlert";
import Toastr from "./components/PluginsMenu/Toastr/Toastr";
import JqvMap from "./components/PluginsMenu/JqvMap/JqvMap";
import Lightgallery from "./components/PluginsMenu/Lightgallery/Lightgallery";

//Redux
//import Todo from "./pages/Todo";

// Widget
import Widget from "./pages/Widget";

/// Table
import SortingTable from "./components/table/SortingTable/SortingTable";
import FilteringTable from "./components/table/FilteringTable/FilteringTable";
import BootstrapTable from "./components/table/BootstrapTable";

/// Form
import Element from "./components/Forms/Element/Element";
import Wizard from "./components/Forms/Wizard/Wizard";
import CkEditor from "./components/Forms/CkEditor/CkEditor";
import Pickers from "./components/Forms/Pickers/Pickers";
import FormValidation from "./components/Forms/FormValidation/FormValidation";

/// Pages
//import Registration from "./pages/Registration";
//import Login from "./pages/Login";
//import ForgotPassword from "./pages/ForgotPassword";
import LockScreen from "./pages/LockScreen";
import Error400 from "./pages/Error400";
import Error403 from "./pages/Error403";
import Error404 from "./pages/Error404";
import Error500 from "./pages/Error500";
import Error503 from "./pages/Error503";
import { ThemeContext } from "../context/ThemeContext";
import LandmarkIndex from "./components/Blocks/LandmarkIndex";

import LandmarkAuthGate from "./Providers/LandmarkAuthGate";
import ReviewSignIn from "./components/Blocks/Landmark/ReviewSignIn";
import ApiService from "../services/ApiService";


// Helper: turn module/element/component into a React element
const resolveToElement = (comp) => {
  // Already a React element?
  if (React.isValidElement(comp)) return comp;

  // Module object with a default export?
  const MaybeComp = comp && (comp.default || comp);

  // If after unwrapping it's a function/class, create an element
  if (typeof MaybeComp === "function") return <MaybeComp />;

  // Not renderable — log for debugging and return null to skip route
  console.error(
    "[Routes] Invalid route component:",
    comp,
    "→ expected a React component/element but got",
    typeof comp
  );
  return null;
};

const LocalRuntimeIndicator = () => {
  const isLocalClient =
    window.location.hostname === "localhost" ||
    window.location.hostname === "127.0.0.1";
  const [status, setStatus] = useState({
    backendTarget: "unknown",
    backendReachable: false,
    databaseTarget: "unknown",
    databaseConnected: false,
    databaseConnectionState: "unknown",
  });
  const [dismissed, setDismissed] = useState(false);
  const [isHovered, setIsHovered] = useState(false);

  useEffect(() => {
    if (!isLocalClient) return;
    let unmounted = false;

    const inferTargetFromApiUrl = (apiUrl) => {
      const normalized = String(apiUrl || "").toLowerCase();
      if (
        normalized.includes("localhost") ||
        normalized.includes("127.0.0.1")
      ) {
        return "local";
      }
      if (normalized.includes("betterblocks.landmarkventures.com")) {
        return "production";
      }
      return "unknown";
    };

    const fetchStatus = async () => {
      try {
        const api = new ApiService();
        const fallbackBackendTarget = inferTargetFromApiUrl(api.apiUrl);
        const resp = await api.get("misc/status");
        if (unmounted) return;
        if (resp && resp.success) {
          setStatus({
            backendTarget: resp.backendTarget || fallbackBackendTarget,
            backendReachable: true,
            databaseTarget: resp.databaseTarget || "unknown",
            databaseConnected: !!resp.databaseConnected,
            databaseConnectionState: resp.databaseConnectionState || "unknown",
          });
        } else {
          setStatus((prev) => ({
            ...prev,
            backendTarget: fallbackBackendTarget,
            backendReachable: false,
            databaseConnected: false,
            databaseConnectionState: "unknown",
          }));
        }
      } catch (error) {
        if (unmounted) return;
        const api = new ApiService();
        setStatus((prev) => ({
          ...prev,
          backendTarget: inferTargetFromApiUrl(api.apiUrl),
          backendReachable: false,
          databaseConnected: false,
          databaseConnectionState: "unknown",
        }));
      }
    };

    fetchStatus();
    const interval = setInterval(fetchStatus, 10000);
    return () => {
      unmounted = true;
      clearInterval(interval);
    };
  }, [isLocalClient]);

  if (!isLocalClient || dismissed) return null;

  const renderRow = (label, value, color, title) => {
    return (
      <div
        key={label}
        title={title}
        style={{
          display: "flex",
          alignItems: "center",
          gap: "6px",
          fontSize: "11px",
          lineHeight: 1.3,
          whiteSpace: "nowrap",
        }}
      >
        <span
          style={{
            width: "8px",
            height: "8px",
            borderRadius: "50%",
            backgroundColor: color,
            display: "inline-block",
            flexShrink: 0,
          }}
        />
        <span style={{ opacity: 0.9 }}>{label}:</span>
        <span style={{ fontWeight: 600 }}>{value}</span>
      </div>
    );
  };

  const backendColor = !status.backendReachable
    ? "#dc3545"
    : status.backendTarget === "local"
    ? "#198754"
    : status.backendTarget === "production"
    ? "#fd7e14"
    : "#6c757d";

  const dbColor = !status.backendReachable
    ? "#dc3545"
    : !status.databaseConnected
    ? "#ffc107"
    : status.databaseTarget === "local"
    ? "#198754"
    : status.databaseTarget === "production"
    ? "#fd7e14"
    : "#6c757d";

  const backendLabel = !status.backendReachable
    ? "unreachable"
    : status.backendTarget === "local"
    ? "localhost"
    : status.backendTarget === "production"
    ? "production"
    : "unknown";

  const databaseLabel = !status.backendReachable
    ? "unknown"
    : status.databaseTarget === "local"
    ? "local db"
    : status.databaseTarget === "production"
    ? "production db"
    : "unknown";

  const dbStateSuffix = status.backendReachable
    ? ` (${status.databaseConnectionState})`
    : "";

  return (
    <div
      onClick={() => setDismissed(true)}
      onMouseEnter={() => setIsHovered(true)}
      onMouseLeave={() => setIsHovered(false)}
      title="Click to hide"
      style={{
        position: "fixed",
        top: "12px",
        right: "12px",
        zIndex: 9999,
        color: "#f8f9fa",
        borderRadius: "8px",
        padding: "8px 10px",
        opacity: isHovered ? 1 : 0.4,
        cursor: "pointer",
      }}
    >
      {renderRow(
        "Backend",
        backendLabel,
        backendColor,
        "Which backend this client is calling"
      )}
      {renderRow(
        "Database",
        `${databaseLabel}${dbStateSuffix}`,
        dbColor,
        "Database target and current backend DB connection state"
      )}
    </div>
  );
};

const Markup = () => {
  const noNavLayoutRoutes = [
    {url: "auth", component: <LandmarkAuthGate element={null} />}, // used to verify magic link
    {url: "landmark/review-signin", component: <ReviewSignIn />}, // sign-in hand-off popup for the Landmark Review iframe
    // dark-themed landmark dashboards: wrapped in LandmarkAuthGate (authGate: true)
    // so the sign-in page renders in place instead of a dead-end "please sign in"
    {
      url: "landmark/events/dashboard",
      component: <EventsDashboard />,
      authGate: true,
    },
    {
      url: "landmark/industrialtech/dashboard",
      component: <IndustrialTechDashboard />,
      authGate: true,
    },
    {
      url: "landmark/dealmakersib/dashboard",
      component: <DealmakersIBDashboard />,
      authGate: true,
    },
    {
      url: "landmark/sisomni/dashboard",
      component: <SISOmniDashboard />,
      authGate: true,
    },
    {
      url: "landmark/israeldealportal/dashboard",
      component: <IsraelDealPortalDashboard />,
      authGate: true,
    },
    { url: "landmark", component: <LandmarkIndex /> },
  ];
  const noNavLayoutRoutesLightBg = [
    { url: "landmark/global/dashboard", component: <GlobalDashboard /> },
    {
      url: "landmark/sisdelegates/dashboard",
      component: <SISDelegateDashboard />,
    },
    { url: "landmark/sweeper", component: <SweeperDashboard /> },
    { url: "landmark/personalizer", component: <PersonalizerDashboard /> },
    { url: "landmark/appetizer/dashboard", component: <AppetizerDashboard /> },
    { url: "landmark/zoom/dashboard", component: <ZoomMeetingDashboard /> },
    { url: "landmark/campaigns", component: <CampaignAttendeeReportingDashboard /> },
    { url: "landmark/sendora", component: <SendoraDashboard /> },
    {
      url: "landmark/emailbounce/dashboard",
      component: <EmailBounceCleanupDashboard />,
    },
    {
      url: "landmark/vipdinner/dashboard",
      component: <DynamicEventsDashboard />,
    },
    { url: "landmark/campaign/dashboard/old", component: <CampaignDashboardOld /> },
    { url: "landmark/campaign/dashboard", component: <CampaignDashboard /> },
    { url: "landmark/campaign/uploader", component: <CampaignDashboard /> },
    { url: "landmark/invoice/dashboard", component: <InvoiceDashboard /> },
    {
      url: "landmark/invoicecustomer/dashboard",
      component: <InvoiceCustomerDashboard />,
    },
    { url: "landmark/deduper", component: <DeDupe /> },
    { url: "landmark/quickcsv", component: <QuickCSVTool /> },
    { url: "landmark/welcome", component: <WelcomePost /> },
    { url: "landmark/contactparser", component: <ContactParser /> },
    { url: "landmark/salesbot", component: <SeamlessBotDashboard /> },
    { url: "landmark/ceosniper", component: <CeoSniperBotDashboard /> },
    { url: "landmark/salesnavbot", component: <LinkedInSalesNavDashboard /> },
    { url: "landmark/linkedin-leads", component: <LinkedInLeadGeneratorDashboard /> },
    {
      url: "landmark/keywordbot",
      component: <SeamlessKeywordSearchDashboard />,
    },
    {
      url: "landmark/tweetsearch",
      component: <TweetSearchDashboard />,
    },
    { url: "landmark/predictionbot", component: <PredictionBotDashboard /> },
    { url: "landmark/website/*", component: <WebsiteCms /> },
    { url: "landmark/bd/*", component: <BdDashboard /> },
    { url: "landmark/oppbot/*", component: <OppBot /> },
    { url: "art/dashboard/*", component: <ArtGalleryDashboard /> },
    { url: "rsop/marketplace/dashboard", component: <MarketplaceDashboard /> },
    { url: "bets/dashboard", component: <BetsDashboard /> },
    { url: "plugins/dashboard", component: <PluginPricesDashboard /> },
  ];
  const allroutes = [
    /// Dashboard
    { url: "", component: <Navigate replace to="/blocks" /> },
    { url: "blocks", component: <BlocksIndex /> },
    { url: "blocks/spotlightbot", component: <SpotlightBotIndex /> },
    { url: "blocks/spotlight", component: <SpotlightBotIndex /> },
    { url: "blocks/salesbot", component: <SalesBotIndex /> },
    { url: "blocks/sales", component: <SalesBotIndex /> },
    { url: "blocks/flexbot", component: <FlexBotIndex /> },
    { url: "tools/snapshot", component: <SnapshotToolIndex /> },
    { url: "blocks/flex", component: <FlexBotIndex /> },
    { url: "blocks/rewardsbot", component: <RewardsBotIndex /> },
    { url: "blocks/rewards", component: <RewardsBotIndex /> },
    { url: "settings", component: <SettingsIndex /> },

    { url: "dashboard", component: <Home /> },
    { url: "dashboard-dark", component: <DashboardDark /> },
    { url: "index-1", component: <Dashboard2 /> },
    { url: "index-3", component: <Dashboard3 /> },
    { url: "index-4", component: <Dashboard4 /> },
    { url: "index-5", component: <Dashboard5 /> },

    //Trading
    { url: "market", component: <Market /> },
    { url: "ico-listing", component: <IcoListing /> },
    { url: "p2p", component: <P2P /> },
    { url: "future", component: <Future /> },
    { url: "intraday-trading", component: <IntradayTrading /> },

    //Crypto
    { url: "crypto", component: <MarketWatch /> },
    { url: "ico-listing-filter", component: <IcoListingFilter /> },
    { url: "banking", component: <Banking /> },
    { url: "exchange", component: <Exchange /> },
    { url: "coin-details", component: <CoinDetails /> },

    //Report
    { url: "history", component: <History /> },
    { url: "orders", component: <Order /> },
    { url: "reports", component: <Reports /> },
    { url: "user", component: <User /> },
    { url: "contact", component: <Contact /> },
    { url: "activity", component: <Activity /> },
    /////Demo
    { url: "sidebar-primary", component: <Theme1 /> },
    { url: "horizontal-sidebar", component: <Theme2 /> },
    { url: "nav-header", component: <Theme3 /> },
    { url: "secondary-header", component: <Theme4 /> },
    { url: "sidebar-theme", component: <Theme5 /> },
    { url: "primary-theme", component: <Theme6 /> },
    { url: "nav-theme", component: <Theme7 /> },
    { url: "sidebar-mini", component: <Theme8 /> },

    /// Apps
    { url: "app-profile", component: <AppProfile /> },
    { url: "edit-profile", component: <EditProfile /> },
    { url: "email-compose", component: <Compose /> },
    { url: "email-inbox", component: <Inbox /> },
    { url: "email-read", component: <Read /> },
    { url: "app-calender", component: <Calendar /> },
    { url: "post-details", component: <PostDetails /> },

    /// Shop
    { url: "ecom-product-grid", component: <ProductGrid /> },
    { url: "ecom-product-list", component: <ProductList /> },
    { url: "ecom-product-detail", component: <ProductDetail /> },
    { url: "ecom-product-order", component: <ProductOrder /> },
    { url: "ecom-checkout", component: <Checkout /> },
    { url: "ecom-invoice", component: <Invoice /> },
    { url: "ecom-customers", component: <Customers /> },
    //
    ///// Chart
    { url: "chart-sparkline", component: <SparklineChart /> },
    { url: "chart-chartjs", component: <ChartJs /> },
    { url: "chart-apexchart", component: <ApexChart /> },
    { url: "chart-rechart", component: <RechartJs /> },
    //
    ///// Bootstrap
    { url: "ui-alert", component: <UiAlert /> },
    { url: "ui-badge", component: <UiBadge /> },
    { url: "ui-button", component: <UiButton /> },
    { url: "ui-modal", component: <UiModal /> },
    { url: "ui-button-group", component: <UiButtonGroup /> },
    { url: "ui-accordion", component: <UiAccordion /> },
    { url: "ui-list-group", component: <UiListGroup /> },
    { url: "ui-card", component: <UiCards /> },
    { url: "ui-carousel", component: <UiCarousel /> },
    { url: "ui-dropdown", component: <UiDropDown /> },
    { url: "ui-popover", component: <UiPopOver /> },
    { url: "ui-progressbar", component: <UiProgressBar /> },
    { url: "ui-tab", component: <UiTab /> },
    { url: "ui-pagination", component: <UiPagination /> },
    { url: "ui-typography", component: <UiTypography /> },
    { url: "ui-grid", component: <UiGrid /> },
    //
    ///// Plugin
    { url: "uc-select2", component: <Select2 /> },
    { url: "uc-noui-slider", component: <MainNouiSlider /> },
    { url: "uc-sweetalert", component: <MainSweetAlert /> },
    { url: "uc-toastr", component: <Toastr /> },
    { url: "map-jqvmap", component: <JqvMap /> },
    { url: "uc-lightgallery", component: <Lightgallery /> },
    //
    /////Redux
    //{ url: "todo", component: Todo },
    //
    ///// Widget
    { url: "widget-basic", component: <Widget /> },

    ///// Form
    { url: "form-element", component: <Element /> },
    { url: "form-wizard", component: <Wizard /> },
    { url: "form-ckeditor", component: <CkEditor /> },
    { url: "form-pickers", component: <Pickers /> },
    { url: "form-validation", component: <FormValidation /> },
    //
    ///// table
    { url: "table-filtering", component: <FilteringTable /> },
    { url: "table-sorting", component: <SortingTable /> },
    { url: "table-bootstrap-basic", component: <BootstrapTable /> },
    //
    ///// pages
    //{ url: "page-register", component: Registration },
    //{ url: "page-lock-screen", component: <LockScreen /> },
    ////{ url: "page-login", component: Login },
    //{ url: "page-forgot-password", component: <ForgotPassword /> },
    //{ url: "page-error-400", component: <Error400 /> },
    //{ url: "page-error-403", component: <Error403 /> },
    //{ url: "page-error-404", component: <Error404 /> },
    //{ url: "page-error-500", component: <Error500 /> },
    //{ url: "page-error-503", component: <Error503 /> },
  ];
  //let path = window.location.pathname;
  //path = path.split("/");
  //path = path[path.length - 1];

  //let pagePath = path.split("-").includes("page");
  //const { menuToggle } = useContext(ThemeContext);

  return (
    <>
      <Routes>
        <Route path="page-lock-screen" element={<LockScreen />} />
        <Route path="page-error-400" element={<Error400 />} />
        <Route path="page-error-403" element={<Error403 />} />
        <Route path="page-error-404" element={<Error404 />} />
        <Route path="page-error-500" element={<Error500 />} />
        <Route path="page-error-503" element={<Error503 />} />
        <Route element={<MainLayout />}>
          {allroutes.map((data, i) => (
            <Route
              key={i}
              exact
              path={`${data.url}`}
              element={data.component}
            />
          ))}
        </Route>
        <Route element={<LayoutNoNav />}>
          {noNavLayoutRoutes.map((data, i) => (
            <Route
              key={i}
              exact
              path={`${data.url}`}
              element={
                data.authGate ? (
                  <LandmarkAuthGate element={data.component} />
                ) : (
                  data.component
                )
              }
            />
          ))}
        </Route>
        <Route element={<LayoutNoNav lightBg={true} />}>
          {noNavLayoutRoutesLightBg.map((data, i) => {
            const pageEl = resolveToElement(data.component);
            if (!pageEl) return null; // skip bad entries gracefully

            const element = data.url.toLowerCase().includes("landmark")
              ? <LandmarkAuthGate element={pageEl} />
              : pageEl;

            return (
              <Route
                key={i}
                path={data.url}
                element={element}
              />
            );
          })}
        </Route>
      </Routes>
      <ScrollToTop />
      <LocalRuntimeIndicator />
    </>
  );
};

function MainLayout() {
  const { menuToggle } = useContext(ThemeContext);
  // const [hasAuthenticated, setHasAuthenticated] = useState(false);
  // const [hasRequestedSignature, setHasRequestedSignature] = useState(false);
  // const account = useAccount();
  // const { data, isError, isLoading, isSuccess, signMessage } = useSignMessage({
  //   message: 'gm wagmi frens',
  // })
  // // check has authenticated
  // if(!hasAuthenticated && account.isConnected) {
  //   if(!hasRequestedSignature) {
  //     signMessage();
  //     setHasRequestedSignature(true)
  //   }
  // }

  return (
    <div
      id="main-wrapper"
      className={`show ${menuToggle ? "menu-toggle" : ""}`}
    >
      <Nav />
      <div
        className="content-body"
        style={{ minHeight: window.screen.height - 45 }}
      >
        <div className="container-fluid">
          <Outlet />
        </div>
      </div>
      <Footer />
    </div>
  );
}

function LayoutNoNav({ lightBg = false }) {
  const { menuToggle } = useContext(ThemeContext);
  const location = useLocation();
  const isSendoraRoute = location.pathname.startsWith("/landmark/sendora");
  // full-bleed tools render their own page chrome
  const isFullBleedRoute =
    isSendoraRoute ||
    location.pathname.startsWith("/landmark/bd") ||
    location.pathname.startsWith("/landmark/oppbot") ||
    location.pathname.startsWith("/landmark/welcome") ||
    location.pathname.startsWith("/art/dashboard");
  // const [hasAuthenticated, setHasAuthenticated] = useState(false);
  // const [hasRequestedSignature, setHasRequestedSignature] = useState(false);
  // const account = useAccount();
  // const { data, isError, isLoading, isSuccess, signMessage } = useSignMessage({
  //   message: 'gm wagmi frens',
  // })
  // // check has authenticated
  // if(!hasAuthenticated && account.isConnected) {
  //   if(!hasRequestedSignature) {
  //     signMessage();
  //     setHasRequestedSignature(true)
  //   }
  // }

  const lightBgClass = lightBg ? "light-bg" : "";
  const sendoraLightBgClass = isSendoraRoute ? "sendora-light-bg" : "";
  return (
    <div
      id="main-wrapper"
      className={`${lightBgClass} ${sendoraLightBgClass} show ${
        menuToggle ? "menu-toggle" : ""
      }`}
    >
      <div
        className="content-body"
        style={{
          minHeight: window.screen.height - 45,
          marginLeft: 0,
          paddingTop: 0,
        }}
      >
        <div
          className="container-fluid"
          style={
            isFullBleedRoute
              ? { paddingLeft: 0, paddingRight: 0, paddingTop: 0 }
              : undefined
          }
        >
          <Outlet />
        </div>
      </div>
      <div style={{ height: "60px" }}></div>
      {/* <Footer /> */}
    </div>
  );
}

export default Markup;
